module.exports = __webpack_public_path__ + "media/images/checkout/icone-cupom-lvnt-c40dba9d631b9914410571b095ed68ac.png";